import { createSlice } from '@reduxjs/toolkit';

export const correcttrackSlice = createSlice({
    name: 'correcttrack',
    initialState: {
        userToken: '',
        refreshToken: '',
        taskFilters: {items: [{}]},
        hazardFilters: {items: [{}]},
        taskQueryId: '',
        hazardColumns: {
            hzId: true,
            hzOrganizationName: true,
            hzProject: true,
            hzRiskSource: true,
            hzDepartmentName: true,
            hzProcess: true,
            hzJob: true,
            hzTask: true,
            hzEquipmentId: true,
            hzRiskScoreUncontrolled: true,
            hzRiskLevelUncontrolled: true,
            hzRiskScoreControlled: true,
            hzRisKLevelControlled: true
        },
        taskColumns: undefined,
    },
    reducers: {
        updateTaskFilters: (state, action) => {
            state.taskFilters = action.payload;
        },
        updateHazardFilters: (state, action) => {
            state.hazardFilters = action.payload;
        },
        updateTaskQuery: (state, action) => {
            state.taskQueryId = action.payload;
        },
        updateHazardColumns: (state, action) => {
            state.hazardColumns = action.payload;
        },
        updateTaskColumns: (state, action) => {
            state.taskColumns = action.payload;
        },
        logout: (state) => {
            state.userToken = '';
            state.refreshToken = '';
            state.forceResetPassword = false;
        },
        updateUserToken: (state, action) => {
            state.userToken = action.payload.token;
            state.refreshToken = action.payload.refreshToken;
        },
    }
});

export const { updateUserToken, logout, updateTaskFilters, updateHazardFilters, updateTaskQuery, updateHazardColumns, updateTaskColumns } = correcttrackSlice.actions;

export default correcttrackSlice.reducer;
